export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    BOX_ALL: function BOX_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/box/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    BOX_CREATE: function BOX_CREATE(data) {
      return request({
        url: '/api/box/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    BOX_DETAIL: function BOX_DETAIL(id) {
      return request({
        url: '/api/box/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    BOX_UPDATE: function BOX_UPDATE(data) {
      return request({
        url: '/api/box/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    BOX_DELETE: function BOX_DELETE(id) {
      return request({
        url: '/api/box/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    BOX_SYNC: function BOX_SYNC(data) {
      return request({
        url: '/api/box/sync',
        method: 'post',
        data: data
      });
    },
    BOX_CLEAR: function BOX_CLEAR(data) {
      return request({
        url: '/api/box/clear/',
        method: 'post',
        data: data
      });
    }
  };
});